import { createSelector } from '@base-ui/utils/store';
import { eventTimelinePremiumPresetSelectors } from "./eventTimelinePremiumPresetSelectors.mjs";
export const timelineOccurrencePlaceholderSelectors = {
  placeholderInResource: createSelector((state, resourceId) => {
    if (state.occurrencePlaceholder === null || state.occurrencePlaceholder.surfaceType !== 'timeline' || state.occurrencePlaceholder.isHidden || state.occurrencePlaceholder.resourceId !== resourceId) {
      return null;
    }
    const presetConfig = eventTimelinePremiumPresetSelectors.config(state);
    if (state.adapter.isBefore(state.occurrencePlaceholder.end, presetConfig.start) || state.adapter.isAfter(state.occurrencePlaceholder.start, presetConfig.end)) {
      return null;
    }
    return state.occurrencePlaceholder;
  }),
  isCreatingInResource: createSelector((state, resourceId) => {
    const placeholder = state.occurrencePlaceholder;
    if (placeholder === null || placeholder.surfaceType !== 'timeline' || placeholder.type !== 'creation' || placeholder.resourceId !== resourceId) {
      return false;
    }
    return true;
  })
};